import { render, staticRenderFns } from "./goods_grid.vue?vue&type=template&id=40cf0e2c&scoped=true"
import script from "./goods_grid.vue?vue&type=script&lang=js"
export * from "./goods_grid.vue?vue&type=script&lang=js"
import style0 from "./goods_grid.vue?vue&type=style&index=0&id=40cf0e2c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40cf0e2c",
  null
  
)

export default component.exports